import { ResolvedIntlConfig } from "react-intl";
import {
  FullLocale,
  getFullLocaleFromVstLocale,
  VstLocale,
} from "../common/utils/locale.ts";
export type MessageData = ResolvedIntlConfig["messages"];

export interface MessageInfo {
  messages: MessageData;
  locale: FullLocale;
}

function isLoadableLocale(locale: FullLocale): boolean {
  return locale !== "en-US";
}

export async function loadLocale(vstLocale: VstLocale): Promise<MessageInfo> {
  const fullLocale = getFullLocaleFromVstLocale(vstLocale);

  // When adding polyfills, be careful about bundle size impact
  if (isLoadableLocale(fullLocale)) {
    try {
      const messages = (await import(`./lang/${fullLocale}.json`)) as {
        default: MessageData;
      };
      return {
        // Many but not all keys exist in the top `messages`; `default` contains them all
        messages: messages.default,
        locale: fullLocale,
      };
    } catch {
      // Hit fallback below
    }
  }
  return { locale: "en-US", messages: {} as MessageData };
}
